import Link from 'next/link';

import { Breadcrumbs, BreadcrumbType } from 'app/shared';
import StaticPagesMenu from '../components/StaticPages/Menu';

import styles from 'global/styles/Contacts.module.scss';

const breadcrumbs: BreadcrumbType[] = [
  {
    title: 'Доставка',
    href: '/dostavka',
  },
];

export default function Delivery() {
  return (
    <div>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className={`${styles.staticPage} container`}>
        <StaticPagesMenu />
        <div className={styles.staticPageContent}>
          <h1 className={styles.staticPageTitle}>Доставка</h1>
          {/* <div className={styles.staticPageInfo}>
            <div>
              <div className={`${styles.staticPageText} ${styles.heavy}`}>Просьба следовать мерам безопасности!</div>
              <div className={styles.staticPageText}>&mdash;&nbsp;соблюдать дистанцию 1.5-2&nbsp;метра.</div>
              <div className={styles.staticPageText}>
                &mdash;&nbsp;находиться в&nbsp;маске и&nbsp;в&nbsp;перчатках с&nbsp;момента получения заказа
                до&nbsp;уезда наших сотрудников.
              </div>
              <div className={styles.staticPageText}>&mdash;&nbsp;проветрить помещение до/после доставки.</div>
            </div>
          </div> */}
          <div className={styles.staticPageInfo}>
            <Link href="/sborka" className={`${styles.staticPageText} ${styles.link} ${styles.dotted}`}>
              Подъем
            </Link>
          </div>
          <div className={styles.staticPageInfo}>
            <div className={styles.staticPageSubTitle} id="delivery">
              Курьерская доставка
            </div>
            <div className={styles.staticPageText}>
              Доставка заказов осуществляется с понедельника по субботу с 8:00 до 24:00
            </div>
            <div className={styles.staticPageText}>
              Оформление доставки вашего товара будет осуществляться на&nbsp;дату, согласованную с&nbsp;вами.
              Подтверждение доставки товаров будет осуществляться во&nbsp;время звонка наших операторов. В&nbsp;день
              доставки вам придет СМС уведомление.
            </div>
            <div className={styles.staticPageTable}>
              <div className={styles.staticPageTableRow}>
                <div className={`${styles.staticPageTableCell} ${styles.staticPageTableCellTitle}`}>Зона доставки</div>
                <div className={`${styles.staticPageTableCell} ${styles.staticPageTableCellTitle}`}>Малогабаритная</div>
                <div className={`${styles.staticPageTableCell} ${styles.staticPageTableCellTitle}`}>Обычная</div>
              </div>
              <div className={styles.staticPageTableRow}>
                <div className={styles.staticPageTableCell}>по&nbsp;Москве в&nbsp;пределах МКАД</div>
                <div className={styles.staticPageTableCell}>1490&nbsp;₽</div>
                <div className={styles.staticPageTableCell}>2490&nbsp;₽</div>
              </div>
              <div className={styles.staticPageTableRow}>
                <div className={styles.staticPageTableCell}>за&nbsp;МКАД и&nbsp;по&nbsp;МО</div>
                <div className={styles.staticPageTableCell}>1490+60&nbsp;₽/км</div>
                <div className={styles.staticPageTableCell}>2490+60&nbsp;₽/км</div>
              </div>
            </div>
            <p>Малогабаритная это до 25 кг.</p>
          </div>
          <div className={styles.staticPageInfo}>
            <div className={styles.staticPageSubTitle} id="express">
              Экспресс-доставка за&nbsp;1&nbsp;день
            </div>
            <div className={styles.staticPageText}>
              Доставка осуществляется в&nbsp;течении 3-6&nbsp;часов, если заказ сделан до&nbsp;17:00. Если заказ сделан
              после 17:00, то&nbsp;доставка осуществляется на&nbsp;следующий день.
            </div>
            <div className={styles.staticPageTable}>
              <div className={styles.staticPageTableRow}>
                <div className={`${styles.staticPageTableCell} ${styles.staticPageTableCellTitle}`}>Зона доставки</div>
                <div className={`${styles.staticPageTableCell} ${styles.staticPageTableCellTitle}`}>Малогабаритная</div>
                <div className={`${styles.staticPageTableCell} ${styles.staticPageTableCellTitle}`}>Обычная</div>
              </div>
              <div className={styles.staticPageTableRow}>
                <div className={styles.staticPageTableCell}>по&nbsp;Москве в&nbsp;пределах МКАД</div>
                <div className={styles.staticPageTableCell}>2980&nbsp;₽</div>
                <div className={styles.staticPageTableCell}>4980&nbsp;₽</div>
              </div>
              <div className={styles.staticPageTableRow}>
                <div className={styles.staticPageTableCell}>за&nbsp;МКАД и&nbsp;по&nbsp;МО</div>
                <div className={styles.staticPageTableCell}>2980+120&nbsp;₽/км</div>
                <div className={styles.staticPageTableCell}>4980+120&nbsp;₽/км</div>
              </div>
            </div>
            <p>Малогабаритная это до 25 кг.</p>
          </div>
          <div className={styles.staticPageInfo}>
            <div className={styles.staticPageSubTitle}>Самовывоз</div>

            <div className={styles.staticPageText}>
              Самовывоз товаров по заказам осуществляется с понедельника по пятницу с 9:00 до 17:00
            </div>
            <div className={styles.staticPageText}>Для получения товара потребуется: номер заказа.</div>
            <div className={styles.staticPageText}>
              Адрес: <br />
              <a
                className={styles.link}
                href="https://yandex.ru/maps/10743/odincovo/house/vnukovskaya_ulitsa_9/Z04YdA9iT00OQFtvfXp0dn5nYQ==/?from=tabbar&ll=37.282690%2C55.657245&source=serp_navig&z=16"
                target="_blank"
                rel="noopener noreferrer"
              >
                Россия, Московская область, Одинцово, Внуковская улица, 9
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
